import { type StaticEncode, Type } from '@sinclair/typebox';
import { ImageSizesSchema, MongooseObjectIdOrStringSchema } from './common.dto.js';
import { TierDTOSchema } from './tier.dto.js';

export const CHANNEL_DESCRIPTION_MAX_LENGTH = 20_000;
export const CHANNEL_TITLE_MAX_LENGTH = 200;

export const ChannelDTOSchema = Type.Object({
  _id: MongooseObjectIdOrStringSchema,
  copyright: Type.Optional(Type.String()),
  description: Type.Transform(Type.String())
    .Decode(v => v)
    .Encode(v => v.slice(0, CHANNEL_DESCRIPTION_MAX_LENGTH)),
  imageSizes: Type.Optional(ImageSizesSchema),
  image30: Type.String(),
  image60: Type.String(),
  image100: Type.String(),
  image600: Type.String(),
  language: Type.Optional(Type.String()),
  lastBuildDate: Type.Optional(Type.Any()),
  link: Type.Optional(Type.String()),
  pubDate: Type.Optional(Type.Any()),
  slug: Type.String(),
  tiers: Type.Array(TierDTOSchema),
  title: Type.Transform(Type.String())
    .Decode(v => v)
    .Encode(v => v.slice(0, CHANNEL_TITLE_MAX_LENGTH)),
});

export type ChannelDTO = StaticEncode<typeof ChannelDTOSchema>;
